module.exports = __webpack_public_path__ + "static/media/Thumbs.6f9f1aa9.db";